import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Timeline } from "./Timeline";
import { Tone } from "../Tone";
/**
 * Represents a single value which is gettable and settable in a timed way
 */
export var TimelineValue = /*#__PURE__*/function (_Tone) {
  _inherits(TimelineValue, _Tone);
  /**
   * @param initialValue The value to return if there is no scheduled values
   */
  function TimelineValue(initialValue) {
    var _this;
    _classCallCheck(this, TimelineValue);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimelineValue).call(this));
    _this.name = "TimelineValue";
    /**
     * The timeline which stores the values
     */
    _this._timeline = new Timeline({
      memory: 10
    });
    _this._initialValue = initialValue;
    return _this;
  }
  /**
   * Set the value at the given time
   */
  _createClass(TimelineValue, [{
    key: "set",
    value: function set(value, time) {
      this._timeline.add({
        value: value,
        time: time
      });
      return this;
    }
    /**
     * Get the value at the given time
     */
  }, {
    key: "get",
    value: function get(time) {
      var event = this._timeline.get(time);
      if (event) {
        return event.value;
      } else {
        return this._initialValue;
      }
    }
  }]);
  return TimelineValue;
}(Tone);